var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-center"},[_c('DevHeader'),_c('DevBody')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }